module.exports = __webpack_public_path__ + "static/media/listMySpaceGreen.00c0d088.svg";